import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppWithRouter from './AppWithRouter';
import Blog from './Blog';
import reportWebVitals from './reportWebVitals';

// Determine which component to render based on URL
const path = window.location.pathname;
const isBlogRoute = path === '/blog' || path === '/blog/' || path.startsWith('/blog/') ||
  path === '/help' || path === '/help/' || path.startsWith('/help/') ||
  (path.match(/^\/([a-zA-Z0-9-]+)$/) && !path.startsWith('/match/') && !path.startsWith('/team-') && path !== '/accept-invite' && path !== '/dashboard' && path !== '/blog-admin' && path !== '/plans');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isBlogRoute ? <Blog /> : <AppWithRouter />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
